const state = {
  visible: false
}

const getters = {
  isVisible: (state) => state.visible
}

const mutations = {
  visible: (state, val) => (state.visible = val)
}

const actions = {
  show: ({ commit }) => commit('visible', true),
  hide: ({ commit }) => commit('visible', false)
}

export default {
  state,
  getters,
  mutations,
  actions
}
